export function getConfiguredRatingOptions (formConfig) {
  const configuredOptions = Array.isArray(formConfig?.rating_options) ? formConfig.rating_options : []
  const descriptions = formConfig?.rating_scale_guide?.descriptions || []
  const options = configuredOptions
    .map(option => ({
      value: Number(option?.value),
      label: option?.label,
      fullLabel: descriptions.find(item => item.code === option?.label)?.rating || option?.label
    }))
    .filter(option => Number.isFinite(option.value) && option.label)
  return options
}

export function getConfiguredRatingDisplay (value, formConfig) {
  if (value === null || value === undefined || value === '') return null
  const numericValue = Number(value)
  return getConfiguredRatingOptions(formConfig).find(option => option.value === numericValue)?.label || `${value}`
}

export function getConfiguredRatingFullLabel (option) {
  return option?.fullLabel || option?.label
}

function getConfiguredRatingGuide (source) {
  const configuredGuide = source?.rating_scale_guide || source?.form_config?.rating_scale_guide
  return configuredGuide && Array.isArray(configuredGuide.descriptions) ? configuredGuide : null
}

export function usesRatingGuideTable (source) {
  return Boolean(getConfiguredRatingGuide(source)?.table_format)
}

export function getEnabledRatingOptions () {
  return []
}

export function getRatingOptionLabel (option) {
  return `${option.value} - ${option.label} (${option.fullLabel})`
}

export function getRatingValueDisplay (value, source) {
  if (value === null || value === undefined || value === '') return null
  const option = getEnabledRatingOptions(source, [value]).find(opt => opt.value === Number(value))
  return option ? getRatingOptionLabel(option) : `${value}`
}

export function getRatingGuideData (source) {
  const configuredGuide = getConfiguredRatingGuide(source)
  if (configuredGuide && Array.isArray(configuredGuide.conversionGuide) && Array.isArray(configuredGuide.descriptions)) {
    return {
      conversionGuide: configuredGuide.conversionGuide,
      descriptions: configuredGuide.descriptions
    }
  }

  return {
    conversionGuide: [],
    descriptions: []
  }
}
